import { useState } from "react";
import { MessageCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { shareInvoiceWhatsApp } from "../lib/whatsapp";

export const WhatsAppShareButton = ({ order, store, className = "", testId }) => {
  const [busy, setBusy] = useState(false);
  const share = async () => {
    setBusy(true);
    try {
      await shareInvoiceWhatsApp(order, store);
    } catch (e) {
      toast.error("Could not prepare invoice for WhatsApp");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button
      type="button"
      onClick={share}
      disabled={busy}
      className={`bg-[#25D366] hover:bg-[#1EBE5A] text-white ${className}`}
      data-testid={testId || `whatsapp-share-${order.id}`}
    >
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <MessageCircle className="h-4 w-4 mr-2" />}
      {busy ? "Preparing invoice…" : "Share on WhatsApp"}
    </Button>
  );
};

export default WhatsAppShareButton;
